import { noteColor, randomScaleNote } from './scale.js';

/** Matrices base de tetrominós (filas × columnas). */
export const TETROMINO_SHAPES = {
  I: [[1, 1, 1, 1]],
  O: [
    [1, 1],
    [1, 1],
  ],
  T: [
    [0, 1, 0],
    [1, 1, 1],
  ],
  S: [
    [0, 1, 1],
    [1, 1, 0],
  ],
  Z: [
    [1, 1, 0],
    [0, 1, 1],
  ],
  J: [
    [1, 0, 0],
    [1, 1, 1],
  ],
  L: [
    [0, 0, 1],
    [1, 1, 1],
  ],
};

export const PIECE_TYPES = Object.keys(TETROMINO_SHAPES);

/** Rota una matriz 90° en sentido horario. */
export function rotateMatrix(matrix) {
  const rows = matrix.length;
  const cols = matrix[0].length;
  const rotated = Array.from({ length: cols }, () => Array(rows).fill(0));
  for (let y = 0; y < rows; y++) {
    for (let x = 0; x < cols; x++) {
      rotated[x][rows - 1 - y] = matrix[y][x];
    }
  }
  return rotated;
}

/**
 * Pieza tetrominó con notas musicales por bloque (Opción A).
 */
export class Piece {
  /**
   * @param {string} type — I, O, T, S, Z, J, L
   * @param {number} [spawnX]
   * @param {number} [spawnY]
   */
  constructor(type, spawnX = 3, spawnY = 0) {
    this.type = type;
    this.x = spawnX;
    this.y = spawnY;
    this.matrix = TETROMINO_SHAPES[type].map((row) => [...row]);
    /** @type {({ note: string, color: string }|null)[][]} */
    this.noteGrid = this.buildNoteGrid(this.matrix);
  }

  /** @param {number[][]} matrix */
  buildNoteGrid(matrix) {
    return matrix.map((row) =>
      row.map((cell) => {
        if (!cell) return null;
        const note = randomScaleNote();
        return { note, color: noteColor(note) };
      })
    );
  }

  rotate() {
    const combined = this.matrix.map((row, y) =>
      row.map((cell, x) => (cell ? this.noteGrid[y][x] : null))
    );
    const newMatrix = rotateMatrix(this.matrix);
    const newCombined = rotateMatrix(
      combined.map((row) => row.map((c) => (c ? 1 : 0)))
    );
    const notes = combined.flat().filter(Boolean);
    let idx = 0;
    this.matrix = newMatrix;
    this.noteGrid = newCombined.map((row) =>
      row.map((cell) => {
        if (!cell) return null;
        const data = notes[idx++];
        const note = data?.note ?? randomScaleNote();
        return { note, color: noteColor(note) };
      })
    );
  }

  /** @returns {{ x: number, y: number, note: string, color: string }[]} */
  blocks() {
    const out = [];
    for (let y = 0; y < this.matrix.length; y++) {
      for (let x = 0; x < this.matrix[y].length; x++) {
        if (this.matrix[y][x] && this.noteGrid[y][x]) {
          out.push({
            x: this.x + x,
            y: this.y + y,
            note: this.noteGrid[y][x].note,
            color: this.noteGrid[y][x].color,
          });
        }
      }
    }
    return out;
  }

  move(dx, dy) {
    this.x += dx;
    this.y += dy;
  }
}

export function createRandomPiece() {
  const type = PIECE_TYPES[Math.floor(Math.random() * PIECE_TYPES.length)];
  return new Piece(type, 3, 0);
}
